import React, { useState, useEffect, createContext } from "react";
import { auth } from '../Firebase/Firebase';
export const UserContext = createContext({ user: null });

//realiza el control de usuario si esta logueado!
export default  ({children}) => {
  const [user, setUser] = useState(null);
  const [inicioS, setInicioS] = useState(false)

   useEffect(() => {
    auth.onAuthStateChanged((u) => {
      if (u) {
        const { displayName, email } = u;
        setUser({
          displayName,
          email,
        })
        setInicioS(true)
      }else{
        setUser(null)
        setInicioS(false)
      }

    });
    
  }, [inicioS]);


  return (
    <UserContext.Provider value={{user, inicioS, setInicioS}}>
        {children}
    </UserContext.Provider>
  );
};